(() => {
  const mainPicker = () => document.querySelector('product-info variant-picker') || document.querySelector('variant-picker');
  const productLink = value => {
    const target = new URL(value, location.origin);
    if (target.origin !== location.origin) return null;
    new URL(location.href).searchParams.forEach((value, name) => {
      if (/^utm_/i.test(name) || ['gclid','fbclid','msclkid','ttclid','preview_theme_id'].includes(name)) target.searchParams.set(name, value);
    });
    target.searchParams.delete('style');
    target.searchParams.delete('variant');
    return target;
  };
  const cleanSelectionUrl = (url, removeVariant = false) => {
    url.searchParams.delete('style');
    if (removeVariant) url.searchParams.delete('variant');
    history.replaceState(history.state, '', url.href);
  };
  const showReset = picker => {
    const source = document.querySelector('ss-auto-links [data-design-reset]');
    if (!source?.textContent) return;
    const note = document.createElement('p');
    note.className = 'ss-auto-design-reset text-sm';
    note.setAttribute('role', 'status');
    note.textContent = source.textContent;
    picker.before(note);
    picker.addEventListener('change', () => note.remove(), {once:true});
  };
  const selectStyle = (picker, style) => {
    const normalized = style.trim().toLowerCase();
    if (!normalized) return false;
    const radios = [...picker.querySelectorAll('input[type="radio"]')].filter(input => input.name.toLowerCase().startsWith('style-'));
    const match = radios.find(input => input.value.toLowerCase() === normalized);
    let control = match;
    if (match) match.checked = true;
    else {
      const select = [...picker.querySelectorAll('select')].find(input => input.name.toLowerCase() === 'options[style]');
      const option = select && [...select.options].find(option => option.value.toLowerCase() === normalized);
      if (!option) return false;
      select.value = option.value;
      control = select;
    }
    const label = control.closest('.variant-input-wrapper')?.querySelector('.form__label span.font-medium');
    if (label) label.textContent = control.value;
    control.dispatchEvent(new Event('change', {bubbles:true}));
    return true;
  };
  const restoreStyleFromUrl = () => {
    const url = new URL(location.href);
    if (!url.searchParams.has('style') && !url.searchParams.has('variant')) return;
    customElements.whenDefined('variant-picker').then(() => {
      const picker = mainPicker();
      if (!picker) return;
      const requestedVariant = url.searchParams.get('variant');
      let selected;
      try { selected = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null'); }
      catch { return; }
      if (requestedVariant && String(selected?.id) === requestedVariant) {
        if (url.searchParams.has('style')) cleanSelectionUrl(url);
        return;
      }
      const style = url.searchParams.get('style');
      if (style && selectStyle(picker, style)) {
        if (requestedVariant) {
          url.searchParams.delete('variant');
          history.replaceState(history.state, '', url.href);
        }
        return;
      }
      cleanSelectionUrl(url, true);
      showReset(picker);
    });
  };
  class ColorLinks extends HTMLElement {
    connectedCallback() { this.addEventListener('change', this.handleChange); }
    disconnectedCallback() { this.removeEventListener('change', this.handleChange); }
    handleChange = event => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-color-links-select]')) return;
      if (!select.value || (select.value === this.dataset.currentUrl && !window.ssProductSwitch?.busy)) return;
      const target = productLink(select.value);
      if (target && this.dispatchEvent(new CustomEvent('ss:product-navigate', {bubbles:true, cancelable:true, detail:{url:target.href, focusMode:'color'}}))) location.assign(target.href);
    };
  }
  if (!customElements.get('color-links')) customElements.define('color-links', ColorLinks);
  restoreStyleFromUrl();
  document.addEventListener('ss:product-loaded', restoreStyleFromUrl);
})();
